// Loads a script the first time it is needed, and reuses the same request after that.
const loading = {};

export function loadScript(src) {
    if (!loading[src]) {
        loading[src] = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    return loading[src];
}
